import React from 'react';
import { Table } from 'react-bootstrap';
import TableRow from './TableRow';

export default function PrizesTable(): JSX.Element {
  const prizes = [
    {
      place: 'Giải nhất',
      name: (
        <>
          Máy tính bảng iPad A16 <br />
          WiFi 128GB
        </>
      ),
      value: '9.720.000 VNĐ',
      amount: '12',
      totalValue: '116.640.000',
    },
    {
      place: 'Giải nhì',
      name: 'Tai nghe AirPods 4',
      value: '2.916.000 VND',
      amount: '24',
      totalValue: '69.984.000',
    },
    {
      place: 'Giải khuyến khích',
      name: 'Cộng sản lượng data 2 GB',
      value: '10.000 VNĐ',
      amount: '2.000',
      subValue: [
        {
          name: 'Cộng tiền vào tài khoản khuyến mại (KM1T/KM99T)',
          value: '10.000 VND',
          amount: '8.000',
          totalValue: '80.000.000',
        },
      ],
      totalValue: '20.000.000',
    },
    {
      place: (
        <>
          Tổng giá trị hàng hóa, dịch vụ dùng để khuyến mại <br />
          (đã bao gồm thuế GTGT)
        </>
      ),
      totalValue: '286.624.000',
    },
  ];
  return (
    <>
      <Table className="table-landing-page-prizes" responsive>
        <thead>
          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
            <th>Giải thưởng</th>
            <th>Chi tiết giải thưởng</th>
            <th>
              Trị giá <br /> (đã bao gồm VAT)
            </th>
            <th>Số lượng</th>
            <th>Tổng giá trị (VND)</th>
          </tr>
        </thead>
        <tbody className="table-drag-item-body">
          {prizes.map((value, index) => {
            const isRowTotal = prizes.length == index + 1;
            const subRows = value.subValue ?? [];
            console.log('subRows', subRows);
            return (
              <React.Fragment key={`item-${index}`}>
                <TableRow
                  name={value.name}
                  place={value.place}
                  value={value.value}
                  amount={value.amount}
                  totalValue={value.totalValue}
                  isRowTotal={isRowTotal}
                  className={subRows.length > 0 ? 'border-none' : ''}
                />
                {!isRowTotal &&
                  subRows.map((sub, subIndex) => (
                    <TableRow
                      key={`item-${index}-sub-${subIndex}`}
                      place=""
                      name={sub.name}
                      value={sub.value}
                      amount={sub.amount}
                      totalValue={sub.totalValue}
                    />
                  ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}
